import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap"
import TreeView from "../../../Components/TreeView/TreeView";
import { useEffect, useState } from "react";
import { getAll } from "../../store/api/eventCategoriesApi";
/**
 * @typedef {object} ModalData
 * @property {boolean} show,
 * @property {function} setSelectedCategory
 */
/**
 * @component
 * @param {object} props 
 * @param {ModalData} props.modalData
 * @param {(modalData: ModalData)=> void} props.setModalData
 * @returns
 */
const ModalSelectCategory = ({ setModalData, modalData }) => {
    // const [nodes, setNodes] = useState({
    //     id: "root",
    //     name: "ریشه",
    //     children: [
    //         {
    //             id: "1",
    //             name: "گره A",
    //             code: "A001",
    //             children: [
    //                 { id: "3", name: "گره C", code: "C001" },
    //                 { id: "4", name: "گره D", code: "D001" },
    //             ],
    //         },
    //         {
    //             id: "2",
    //             name: "گره B",
    //             code: "B001",
    //         },
    //     ],
    // });
    const [nodes, setNodes] = useState(null);
    const close = () => {
        setModalData({ show: false });
        if (typeof modalData.setSelectedCategory === "function")
        {
            modalData.setSelectedCategory(null);
        }
    }
    const setSelectedNode = (node) => {
        if (typeof modalData.setSelectedCategory === "function")
            modalData.setSelectedCategory(node);
        setModalData({ show: false });
    }
    useEffect(() => {
        if(modalData.show)
        {
        const onSet = (res) => {
            if (res.Data) {
                setNodes(res.Data[0]);
            }
        }
        getAll(0, onSet);
    }
    }, [modalData.show])
    return (
        <Modal show={modalData.show}>
            <Modal.Header className="headerStyle">
                <span>
                    دسته بندی رویدادها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {nodes &&
                    <TreeView nodes={nodes} setNodes={setNodes} setSelectedNode={setSelectedNode} />}
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectCategory;